import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';


export default function initSingleContentSlider(): void {
    const $singleContentSlidercontainer = document.querySelectorAll<HTMLElement>('.js-content-slider');
    $singleContentSlidercontainer.forEach($container => {
        new SingleContentSlider($container);
    });
}

class SingleContentSlider {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    $navigation_prev: HTMLElement | null | undefined;
    $navigation_next: HTMLElement | null | undefined;
    $pagination: HTMLElement | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = $el?.querySelector('.slider');
        this.$navigation_prev = $el?.querySelector('.button-prev');
        this.$navigation_next = $el?.querySelector('.button-next');
        this.$pagination = $el?.querySelector('.slider-pagination');
        this.init();
    }

    init(): void {
        if (this.$slider) {
            this.swiper = new Swiper(this.$slider, {
                modules: [Navigation, Pagination],
                slidesPerView: 'auto',
                loop: false,
                grabCursor: true,
                allowTouchMove: true,
                spaceBetween: 20,
                navigation: {
                    nextEl: this.$navigation_next,
                    prevEl: this.$navigation_prev,
                },
                pagination: {
                    el: this.$pagination,
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                    },
                },
            });
        }
    }
}
